import React, { useContext, useEffect, useState } from "react";
import {
  collection,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

import css from "./AdminPage.module.css";
import { DataContext } from "../../context/DataContext";
import { Head } from "../../utils/Head";
import { UserContext } from "../../context/UserContext";
import { db } from "../../services/firebaseConfig";
import { updateUserFirebase } from "../../services/firebaseService";

export const AdminPage = () => {
  const { mindList, moveList, nutriList, valuesList } = useContext(DataContext);
  const { users } = useContext(UserContext);
  const [purchasePending, setPurchasePending] = useState([]);
  const [proPending, setProPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const q = query(
      collection(db, "premiumRequests"),
      where("status", "==", "pending")
    );
    const unsub = onSnapshot(q, (snap) => {
      const list = [];
      snap.forEach((s) => list.push({ id: s.id, ...s.data() }));
      setPurchasePending(list);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const q = query(
      collection(db, "registrations"),
      where("status", "==", "pending")
    );
    const unsub = onSnapshot(q, (snap) => {
      const list = [];
      snap.forEach((s) => list.push({ id: s.id, ...s.data() }));
      setProPending(list);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const approve = async (reg) => {
    try {
      await updateDoc(doc(db, "premiumRequests", reg.id), {
        userName: reg.userName,
        userEmail: reg.userEmail,
        userId: reg.userId,
        createdAt: reg.createdAt,
        payload: reg.payload,
        receiptUrl: reg.receiptUrl,
        id: reg.id,
        status: "approved",
        approvedAt: serverTimestamp(),
        approvedBy: auth.currentUser?.uid || null,
      });

      const selectedUser = users.find((u) => u.id === reg.userId);
      if (!selectedUser) {
        console.warn("Usuário não encontrado");
        return;
      }
      const updatedUser = { ...selectedUser };
      updatedUser.userType.premiumReport = true;

      updateUserFirebase(updatedUser);
    } catch (err) {
      console.error("Erro aprovar", err);
      alert("Erro ao aprovar: " + (err.message || err));
    }
  };

  if (loading) return <div>Carregando...</div>;

  return (
    <div className={css.container}>
      <Head title="Admin" description={"Admin - Mairini"} />

      <h2>Compras de Relatórios</h2>
      {purchasePending.length === 0 && <div>Nenhuma compra pendente.</div>}

      {purchasePending.map((reg) => (
        <li key={reg.id} className={css.card}>
          <p>
            <strong>{reg.userName}</strong>
          </p>
          <p>email: {reg.userEmail}</p>
          <p>UserId: {reg.userId}</p>
          <div style={{ marginTop: "1rem" }}>
            <button onClick={() => approve(reg)} className="blueButton">
              Aprovar relatório premium
            </button>
            <button
              style={{ marginTop: "1rem" }}
              className="redButton"
              onClick={() =>
                updateDoc(doc(db, "premiumRequests", reg.id), {
                  userName: reg.userName,
                  userEmail: reg.userEmail,
                  userId: reg.userId,
                  createdAt: reg.createdAt,
                  payload: reg.payload,
                  receiptUrl: reg.receiptUrl,
                  id: reg.id,
                  status: "rejected",
                  rejectedAt: serverTimestamp(),
                  rejectedBy: auth.currentUser?.uid || null,
                })
              }
            >
              Rejeitar
            </button>
          </div>
          {reg.message && (
            <div style={{ marginTop: 6, fontStyle: "italic" }}>
              {reg.message}
            </div>
          )}
        </li>
      ))}

      <div className={css.card}>
        <h5>Compra de relatório solicitada</h5>
      </div>

      <h2>Inscrições no Grupo Pro</h2>
      {proPending.length === 0 && <div>Nenhuma inscrição pendente.</div>}
      <ul>
        {proPending.map((reg) => (
          <li key={reg.id} className={css.card}>
            <strong>{reg.name}</strong> — {reg.profession} — {reg.email}
            <div style={{ marginTop: "1rem" }}>
              <button onClick={() => approve(reg)} className="blueButton">
                Aprovar e enviar convite
              </button>
              <button
                style={{ marginTop: "1rem" }}
                className="redButton"
                onClick={() =>
                  updateDoc(doc(db, "registrations", reg.id), {
                    status: "rejected",
                    rejectedAt: serverTimestamp(),
                    rejectedBy: auth.currentUser?.uid || null,
                  })
                }
              >
                Rejeitar
              </button>
            </div>
            {reg.message && (
              <div style={{ marginTop: 6, fontStyle: "italic" }}>
                {reg.message}
              </div>
            )}
          </li>
        ))}
      </ul>

      <h2>Dados Gerais</h2>

      <div className={css.card}>
        <h5>Usuários</h5>
        <p>Usuários: {users.length}</p>
      </div>
      <div className={css.card}>
        <h5>Atividades</h5>
        <p>Mind: {mindList.length}</p>
        <p>Move: {moveList.length}</p>
        <p>Nutri: {nutriList.length}</p>
        <p>Values: {valuesList.length}</p>
      </div>
    </div>
  );
};
